module.exports = __webpack_public_path__ + "static/media/dummy-error-image.13c108f4.jpg";